import type {
  CheckoutPayload,
  StripeRedirect,
} from '@octopus-do/octopus-api-client'
import { LoaderActions } from '@store/loaders'
import type { UpgradePlanActions } from '@store/reducers/upgradePlan'
import { ContactSupportErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'

export function* updatePayment({
  payload: { planId, planType },
}: ReturnType<typeof UpgradePlanActions.updatePayment>) {
  yield put(LoaderActions.set('upgrade_plan'))

  const couponCode = window.sessionStorage.getItem('coupon_code')

  const payload: CheckoutPayload = {
    planId: planId as CheckoutPayload['planId'],
    planType,
    ...(couponCode && { couponCode }),
  }

  try {
    const { url }: StripeRedirect = yield call(
      NestClient.subscription.checkout,
      payload
    )

    if (url) {
      window.location.href = url
    }
  } catch (e) {
    console.error('Error in updatePayment:', e)

    yield put(ContactSupportErrorNotification)
  } finally {
    yield put(LoaderActions.unset('upgrade_plan'))
  }
}
